import React from "react"

import { Project } from "shared/types/Project"
import { SelectOption } from "shared/types/Select"
import { PartialWithID } from "shared/types/WithID"

import { ActiveProjectSelectView } from "./ActiveProjectSelectView"
import { useActiveProjectSelectViewModel } from "./hooks/useActiveProjectSelectViewModel"

export interface ActiveProjectSelectModel {
  activeProject: Project | null
  activeProjectHref?: string
  isLoading?: boolean
  options: SelectOption<string, Project>[]
  value?: string | null
  tabIndex?: number
  onNavigateToActiveProject: () => void
  onChange: (projectID: string | null) => void
  onCreate: (project: PartialWithID<Project>) => void
}

export const ActiveProjectSelect = React.memo(
  (props: ActiveProjectSelectModel) => (
    <ActiveProjectSelectView {...useActiveProjectSelectViewModel(props)} />
  )
)
